/** Privacy settings for new domain registrations and incoming transfers. */
export const DOMAIN_PRIVACY = {
 mode:'standard',
 whoisProxy:false,
 publishContactData:false,
 name:'Standard privacy',
 description:'We do not consent to publication of your personal contact data. Public details depend on the domain registry rules.',
} as const;

export function domainPrivacyStatus(whoisProxy:boolean|null,publishContactData:boolean|null):string{
 if(whoisProxy===true)return 'WHOIS proxy protection enabled';
 if(publishContactData===false)return 'Standard privacy — contact data publication disabled';
 if(publishContactData===true)return 'Contact data publication enabled';
 return 'Contact data publication status has not been reported';
}
